import { Configuration, SuppliersApi } from '@/api';
import { fetchAllPaginated } from '@/api/utils';
import SelectBox, { Item, SelectBoxProps } from '@/components/select/SelectBox';
import { Supplier } from '@/models/Supplier';
import { useAuth } from '@/modules/auth/contexts/AuthContext';

type SupplierSelectBoxProps<T extends Item> = SelectBoxProps<T> & {
  createdByStoreId?: string;
};

const SupplierSelectBox = ({ createdByStoreId, ...props }: SupplierSelectBoxProps<Supplier>) => {
  const suppliersApi = new SuppliersApi(new Configuration(useAuth));

  const listSuppliers = async (): Promise<Supplier[]> => {
    return await fetchAllPaginated<Supplier>(
      (offset, limit) => suppliersApi.findSuppliers(undefined, { createdByStoreId }, offset, limit),
      100,
      1000,
    );
  };

  const { label = 'Supplier:', placeholder = 'Select supplier' } = props;

  return (
    <SelectBox<Supplier>
      {...props}
      name="supplier"
      label={label}
      placeholder={placeholder}
      queryFn={listSuppliers}
      queryKey={['supplier', createdByStoreId || '']}
    />
  );
};

export default SupplierSelectBox;
